import { intlFormat } from 'date-fns/fp'
import { pipe } from '@packages/prelude'

type FormatOptions = typeof intlFormat extends (a: any, b: infer T) => any ? T : never

export const format = (formatOptions: FormatOptions) => (date: Date | number) =>
  pipe(date, intlFormat({ locale: 'de-DE' })({ day: '2-digit', month: '2-digit', year: 'numeric', ...formatOptions }))
